var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppraisal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 17.8439L12.5 15.9168L15 17.8439L14.0625 14.6668L16.4062 13.0002H13.4896L12.5 9.771L11.5104 13.0002H8.59373L10.9375 14.6668L9.99998 17.8439ZM6.06769 23.4168L8.48956 15.5002L2.08331 10.9168H9.99998L12.5 2.5835L15 10.9168H22.9166L16.5104 15.5002L18.9323 23.4168L12.5 18.521L6.06769 23.4168Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppraisal);
export default __webpack_public_path__ + "static/media/appraisal.9604f805c10bdfd3ec40c000b73d408e.svg";
export { ForwardRef as ReactComponent };